import React from 'react'

import './notFound.css';
let NoteFound=()=> {
  return (
    <div className='notFoundPage'>The page you are looking is not found</div>
  )
}

export default NoteFound